import Vue from 'vue'
import Router from 'vue-router'
import newRouter from './newRouter'
// 初始化 api（非页面组件，保持静态引入）
import DIC_API from "@/api/api_dictionary"
import api_dept from "@/api/api_dept.js"
import api_user from "@/api/api_user.js"
import $const from "@/common/constant"
import config from '@/config/config.js'

// 路由组件统一懒加载：访问时再加载对应 chunk
const Home = () => import('@/layout/index.vue')
const Dashboard = () => import('@/components/Dashboard')
const BookList = () => import('@/components/role/list')
const ChartsConfList = () => import('@/components/chart/list')
const UserList = () => import('@/components/user/list')
const UserChangePwd = () => import('@/components/user/changepwd')
const UserProfile = () => import('@/components/user/profile')
const MenuList = () => import('@/components/menu/list')
const Department = () => import('@/pages/RightsManagement/Department')
const Ent = () => import('@/pages/EntManagenment/entList')
const Employee = () => import('@/pages/EntManagenment/employee/list')
const TrainingEmployee = () => import('@/pages/EntManagenment/employee/trainingList')
const EmployeeFile = () => import('@/pages/EntManagenment/employee/file')
const EmployeeTrainingRecord = () => import('@/pages/EntManagenment/employee/trainingRecord')
const Post = () => import('@/pages/EntManagenment/post/list')
const Job = () => import('@/pages/EntManagenment/job/list')
const RiskUnit = () => import('@/pages/RiskManagement/riskUnit')
const publicRiskUnit = () => import('@/pages/RiskManagement/publicRiskUnit')
const RiskPosition = () => import('@/pages/RiskManagement/riskPosition')
const RiskControl = () => import('@/pages/RiskManagement/riskControl')
const BasicInfo = () => import('@/pages/Hidden/basicInfo')
const HRepository = () => import('@/pages/Hidden/checkList/repository')
const CheckList = () => import('@/pages/Hidden/check/list')
const CheckAdd = () => import('@/pages/Hidden/check/add')
const Relevant = () => import('@/pages/thirdParty/relevant/relevant')
const HaveDone = () => import('@/pages/Backlog/haveDone')
const Version = () => import('@/pages/baseinfo/version/list')
const ApprovalList = () => import('@/pages/Hidden/check/approvalList')
const RiskEventType = () => import('@/pages/RiskManagement/riskEventType')
const LawList = () => import('@/pages/knowledgeBase/law/list')
const SubList = () => import('@/pages/knowledgeBase/law/subList')
const RulesTypeList = () => import('@/pages/knowledgeBase/rules/rulesTypeList')
const RulesList = () => import('@/pages/knowledgeBase/rules/list')
const SeTargetNameList = () => import('@/pages/security/target/list')
const SeTargetList = () => import('@/pages/security/target/needList')
const SeNextList = () => import('@/pages/security/target/nextList')
const EReportList = () => import('@/pages/ereport/list')
const ExpertList = () => import('@/pages/emergency/expert/list')
const MaterialList = () => import('@/pages/emergency/materials/list')
const TeamList = () => import('@/pages/emergency/team/list')
const DrillPlanList = () => import('@/pages/emergency/drillplan/list')
const EntAttList = () => import('@/pages/EntManagenment/att/list')
const StandardList = () => import('@/pages/security/industry/stalist')
const IndustryList = () => import('@/pages/security/industry/qualist')
const DrillList = () => import('@/pages/emergency/drill/list')
const DutyEmployeeList = () => import('@/pages/emergency/dutyemployee/list')
const ProList = () => import('@/pages/proManagenment/pro/proList')
const HarmfulType = () => import('@/pages/EntManagenment/od/harmfulType')
const HarmfulFactor = () => import('@/pages/EntManagenment/od/harmfulFactor')
const HealthExamination = () => import('@/pages/EntManagenment/professional/healthExamination')
const ProtectiveEquipmentBasic = () => import('@/pages/EntManagenment/labour/protectiveEquipmentBasic')
const DictionaryList = () => import('@/pages/security/dictionary/list')
const TypeDictionaryList = () => import('@/pages/security/typeDictionary/list')
const RegulationsList = () => import('@/pages/security/regulations/list')
const Course = () => import('@/pages/training/course')
const PlatformManagement = () => import('@/pages/PlatformManagement/index')
// 企业文件
const EntFile = () => import('@/pages/EntManagenment/file/EntFile.vue')
const securitySupervisorList = () => import('@/pages/EntManagenment/file/securitySupervisor/list.vue')
// 需求调查表下载
const trainingNeedsList = () => import('@/pages/EntManagenment/file/TrainingNeeds/list.vue')
// 安全培训费用提取和使用管理台账
const trainingFeeList = () => import('@/pages/EntManagenment/file/trainingFee/list.vue')
// 培训师资管理台账
const teacherLedgerList = () => import('@/pages/EntManagenment/file/teacherLedger/list.vue')
// 清单式隐患排查流程
const listHiddenCheckList = () => import('@/pages/Hidden/listHiddenCheck/list')
const Login = () => import('@/components/Login')
const JgLogin = () => import('@/components/JgLogin')
const wechatMall = () => import('@/components/hmall')
const wechatMallType = () => import('@/components/hmallType')
// webIndex / about
const webIndex = () => import('@/pages/webMall/index/index.vue')
const webAbout = () => import('@/pages/webMall/about/index.vue')
const UserInitialization = () => import('@/components/UserInitialization')
// 注册页面
const Register = () => import('@/components/register/index')
const Success = () => import('@/components/register/success')
const invite = () => import('@/pages/EntManagenment/invite/popup/start.vue')
const Recommend = () => import('@/components/recommend/index.vue')
const Customer = () => import('@/components/customer/index.vue')
const Detail = () => import('@/pages/webMall/index/detail.vue')
// 异常页面
const NotFount = () => import('@/pages/exception/404')

Vue.use(Router)


let router = new Router({
  mode: 'history',
  //base: '/dist',
  routes: [
    {
      path: "/404",
      name: "notFound",
      component: NotFount
    },
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404" //无匹配到的路径自动重定向到404页面
    },
    {
      path: '/login',
      name: '登录',
      component: Login
    },

    {
      path: '/org-login',
      name: '登录 ',
      component: () => import('@/components/orgLogin.vue'),
    },
    {
      path: '/webs-index',
      name: '首页 ',
      component: () => import('@/pages/home/index.vue'),
    },
    {
      path: '/jg-login',
      name: '监管端登录',
      component: JgLogin
    },
    {
      path: '/customer',
      name: '提示',
      component: Customer
    },
    {
      path: '/invite',
      name: '启动',
      component: invite
    },
    {
      path: '/register',
      name: '注册',
      component: Register
    },
    {
      path: '/cadet/register',
      name: '注册',
      component: () => import('@/components/cadet/register/index.vue'),
    },

    {
      path: '/success',
      name: '注册成功',
      component: Success
    },

    {
      path: '/recommend',
      name: '推荐',
      component: Recommend
    },

    {
      path: '/supervise',
      name: '商品详情 ',
      component: () => import('@/components/supervise/index.vue'),
    },
    {
      path: '/h/mall',
      name: '商城',
      component: wechatMall
    },
    {
      path: '/web-index',
      name: '商城',
      meta: {
        group: 'mall'
      },
      component: webIndex
    },
    {
      path: '/about',
      name: '关于我们',
      component: webAbout,
      meta: {
        group: 'mall'
      },
    },
    {
      path: '/detail',
      name: '商品详情 ',
      component: Detail
      // component: () => import('@/pages/webMall/index/detailTop.vue'),
    },

    {
      path: '/chart001',
      name: '图表 ',
      component: () => import('@/components/supervise/component/chart/chart001.vue'),
    },
    {
      path: '/enter',
      name: '报告 ',
      component: () => import('@/components/enter/indexCes.vue'),
    },
    {
      path: '/indexCes',
      name: '人保 ',
      component: () => import('@/components/enter/indexCes.vue'),
    },
    {
      path: '/h/mall/type',
      name: '商城',
      component: wechatMallType,
      meta: {
        group: 'mall'
      },
    },

    {
      path: '/user/initialization',
      name: '账号初始化',
      component: UserInitialization
    },
    {
      path: '/datastatic',
      name: '数据看板',
      component: () => import('@/components/Datastatic')
    },
    {
      path: '/datastatic3',
      name: '集团看板',
      component: () => import('@/components/Datastatic3')
    },
    {
      path: '/videoSurveillance',
      name: '视频监控',
      component: () => import('@/components/VideoSurveillance')
    },
    {
      path: '/videoList',
      name: '视频列表',
      component: () => import('@/components/training/videoList.vue')
    },
    {
      path: '/activate',
      name: '激活',
      component: () => import('@/components/activate')
    },
    // {
    //   path: '/archives/ent/overall',
    //   component: () => import('@/pages/trainingManagement/archives/overall/index.vue'),
    //   name: '一人一档',
    //   menuShow: true
    // },
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/dashboard',
      leaf: true, // 只有一个节点
      menuShow: true,
      iconCls: 'fa fa-home', // 图标样式class
      children: [{
        path: '/dashboard',
        // component: Dashboard,
        component: () => import('@/components/DashboardStatistics.vue'),
        name: '首页',
        menuShow: true
      },
        {
          path: '/sheet',
          name: '答题首页',
          component: () => import('@/pages/answerSheet/index.vue'),
        },
        {
          path: '/no-data',
          name: '暂无数据',
          component: () => import('@/pages/answerSheet/common/noData.vue'),
        },



        {
          path: '/answer',
          name: '答题',
          component: () => import('@/pages/answerSheet/common/answer/answer.vue'),
        },
        {
          path: '/help',
          name: '帮助中心 ',
          component: () => import('@/components/help/index.vue'),
        },
        {
          path: '/manage/help',
          name: '帮助中心 ',
          component: () => import('@/pages/help/index.vue'),

        },
        {
          path: '/manage/help/add',
          name: '新增 ',
          meta: {activeMenu: '/manage/help'},
          component: () => import('@/pages/help/common/add.vue'),
        },
      ]
    },

    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/demo',
      leaf: true, // 只有一个节点
      menuShow: true,
      iconCls: 'fa fa-home', // 图标样式class
      children: [{
        path: '/demo',
        component: () => import('@/components/DashboardStatistics.vue'),
        name: '统计',
        menuShow: true
      }]
    },
    {
      path: '/questionBank',
      component: Home,
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'fa fa-user', // 图标样式class
      children: [{
        path: '/',
        name: '题库管理',
        component: () => import('@/pages/questionBank/index.vue'),
      },{
        path: '/questionBank/question',
        name: '题库列表',
        component: () => import('@/pages/questionBank/common/question.vue')
      }
      ,{
        path: '/questionBank/question/detail',
        name: '试题详情',
        component: () => import('@/pages/questionBank/common/questionOperate.vue')
      },{
        path: '/questionBank/question/add',
        name: '试题新增',
        component: () => import('@/pages/questionBank/common/questionOperate.vue')
      },{
        path: '/questionBank/question/edit',
        name: '试题编辑',
        component: () => import('@/pages/questionBank/common/questionOperate.vue')
      }]
    },
    {
      path: '/',
      component: Home,
      name: '商城',
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'fa fa-user', // 图标样式class
      children: [{
        path: '/course/mall',
        name: '商城',
        component: () => import('@/components/courseMall/index.vue'),
      },
        {
          path: '/course/mall/detail',
          name: '商品详情',
          component: () => import('@/components/courseMall/detail.vue'),
        }
      ]
    },
    {
      path: '/',
      component: Home,
      name: '用户管理',
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'fa fa-user', // 图标样式class
      children: [{
        path: '/admin/list',
        component: UserList,
        name: '用户列表',
        menuShow: true
      },
        {
          path: '/admin/user',
          component: () => import('@/components/user/list.vue'),
          name: '用户列表',
          menuShow: true
        },
        {
          path: '/admin/member',
          component: () => import('@/components/user/member.vue'),
          name: '成员管理',
          menuShow: true
        }
      ]
    },
    {
      path: '/',
      component: Home,
      name: '平台管理',
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'fa fa-user', // 图标样式class
      children: [
        {path: '/admin/platform', component: PlatformManagement, name: '平台列表', menuShow: true}
      ]
    },
    {
      path: '/',
      component: Home,
      name: '菜单管理',
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'fa fa-server', // 图标样式class
      children: [{
        path: '/admin/menu',
        component: MenuList,
        name: '菜单列表',
        menuShow: true
      }]
    },
    {
      path: '/',
      component: Home,
      name: '应急管理',
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: 'fa fa-server', // 图标样式class
      children: [{
        path: '/emergency/expert',
        component: ExpertList,
        name: '应急专家',
        menuShow: true
      },
        {
          path: '/emergency/materials',
          component: MaterialList,
          name: '应急物资',
          menuShow: true
        },
        {
          path: '/emergency/team',
          component: TeamList,
          name: '应急队伍',
          menuShow: true
        },
        {
          path: '/emergency/drillplan',
          component: DrillPlanList,
          name: '演练计划',
          menuShow: true
        },
        {
          path: '/emergency/drill',
          component: DrillList,
          name: '应急演练',
          menuShow: true
        },
        {
          path: '/emergency/dutyemployee',
          component: DutyEmployeeList,
          name: '应急值守人员',
          menuShow: true
        },
        {
          path: '/emergency/dutyevent',
          component: () => import('@/pages/emergency/dutyemployee/dutyevent'),
          name: '值班排班',
          menuShow: true
        },
        {
          path: '/emergency/emanagement',
          component: () => import('@/pages/emergency/emanagement/list'),
          name: '应急预案',
          menuShow: true
        },
        {
          path: '/emergency/eventdeal',
          component: () => import('@/pages/emergency/emanagement/eventlist'),
          name: '应急事件处理',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '角色管理',
      menuShow: true,
      leaf: true,
      iconCls: 'fa fa-group',
      children: [{
        path: '/admin/role',
        component: BookList,
        name: '角色列表',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: '报表管理',
      menuShow: true,
      leaf: true,
      iconCls: 'fa fa-group',
      children: [{
        path: '/admin/chart/list',
        component: ChartsConfList,
        name: '报表列表',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: '设置',
      menuShow: true,
      iconCls: 'iconfont icon-setting1',
      children: [{
        path: '/user/profile',
        component: UserProfile,
        name: '个人信息1',
        menuShow: true
      },
        {
          path: '/user/changepwd',
          component: UserChangePwd,
          name: '修改密码',
          menuShow: true
        }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '注册服务',
      menuShow: true,
      iconCls: 'iconfont icon-setting1',
      children: [{
        path: '/service',
        component: UserProfile,
        redirect: 'http://baidu.com',
        target: '_blank',
        name: '注册服务列表',
        menuShow: true
      },]
    },

    {
      path: '/',
      component: Home,
      name: '部门管理菜单',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/department',
        component: Department,
        name: '部门管理',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: '平台流水',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/running/index',
        component: () => import('@/pages/running/index.vue'),
        name: '平台流水',
        menuShow: true
      },]
    },

    {
      path: '/',
      component: Home,
      name: '企业管理',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/ent',
        component: Ent,
        name: '企业基本信息',
        menuShow: true
      },
        {
          path: '/employee',
          component: Employee,
          name: '员工管理',
          menuShow: true
        },
        {
          path: '/t-employee',
          component: TrainingEmployee,
          name: '员工管理',
          menuShow: true
        },
        {
          path: '/employee/file',
          component: EmployeeFile,
          name: '员工档案',
          menuShow: true,
          meta: {activeMenu: '/t-employee'},
        },
        {
          path: '/employee/employeeTrainingRecord',
          component: EmployeeTrainingRecord,
          name: '员工培训记录',
          menuShow: true,
          meta: {activeMenu: '/t-employee'},
        },
        {
          path: '/securitySupervisor/list',
          component: securitySupervisorList,
          name: '任命安全教育主管',
          menuShow: true
        },
        {
          path: '/trainingNeedsList/list',
          component: trainingNeedsList,
          name: '培训需求调查',
          menuShow: true
        },
        {
          path: '/trainingFee/list',
          component: trainingFeeList,
          name: '安全培训费用提取和使用管理台账',
          menuShow: true
        },
        {
          path: '/teacherLedger/list',
          component: teacherLedgerList,
          name: '培训师资管理台账',
          menuShow: true
        },
        {
          path: '/diseasesType',
          component: () => import('@/pages/EntManagenment/od/diseasesType'),
          name: '职业病种类管理',
          menuShow: true
        },
        {
          path: '/erule/list',
          component: () => import('@/pages/erule/main'),
          name: '规章制度',
          menuShow: true
        },
        {
          path: '/harmfulDiscern',
          component: () => import('@/pages/EntManagenment/od/harmfulDiscern'),
          name: '职业病危害因素识别',
          menuShow: true
        },
        {
          path: '/typeOfWork',
          component: () => import('@/pages/EntManagenment/typeOfWork/typeOfWork'),
          name: '工种管理',
          menuShow: true
        },
        {
          path: '/exposedPerson',
          component: () => import('@/pages/EntManagenment/od/exposedPerson'),
          name: '职业危害人员',
          menuShow: true
        },
        {
          path: '/organization',
          component: () => import('@/pages/organization/list'),
          name: '机构管理',
          menuShow: true
        },
        {
          path: '/organization/user',
          component: () => import('@/pages/organization/organizationuserlist'),
          name: '机构人员管理',
          menuShow: true
        },
        {
          path: '/eTypeDictionary/list',
          component: () => import('@/pages/security/typeDictionary/eList'),
          name: '企业类型管理',
          menuShow: true
        },
        {
          path: '/eRegulations/list',
          component: () => import('@/pages/security/regulations/main'),
          name: '操作规程',
          menuShow: true
        },
        {
          path: '/bounded/list',
          component: () => import('@/pages/security/bounded/list'),
          name: '有（受）限空间管理',
          menuShow: true
        },
        {
          path: '/testing/list',
          component: () => import('@/pages/security/testing/list'),
          name: '第三方检测',
          menuShow: true
        },
        {
          path: '/assessment/list',
          component: () => import('@/pages/security/assessment/list'),
          name: '第三方评估',
          menuShow: true
        },
        {
          path: '/dust/list',
          component: () => import('@/pages/security/dust/list'),
          name: '粉尘涉爆',
          menuShow: true
        },
        {
          path: '/messageNotification/message',
          component: () => import('@/pages/EntManagenment/messageNotification/message'),
          name: '消息通知',
          menuShow: true
        },
      ]
    }, {
      path: '/',
      component: Home,
      name: '制度化建设',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/complainceComment',
        component: () => import('@/pages/complainceComment/complainceComment'),
        name: '合规性评价',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: '职业健康管理',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/harmfulType',
        component: HarmfulType,
        name: '职业病危害类型管理',
        menuShow: true
      },
        {
          path: '/harmfulFactor',
          component: HarmfulFactor,
          name: '职业病危害因素管理',
          menuShow: true
        },
        {
          path: '/healthExamination',
          component: HealthExamination,
          name: '职业健康检查管理',
          menuShow: true
        },
        {
          path: '/protectiveEquipmentBasic',
          component: ProtectiveEquipmentBasic,
          name: '劳动防护用品基础信息管理',
          menuShow: true
        },
        {
          path: '/protectiveEquipmentRecord',
          component: () => import('@/pages/EntManagenment/labour/protectiveEquipmentRecord'),
          name: '劳动防护用品发放管理',
          menuShow: true
        },
      ]
    }, {
      path: '/',
      component: Home,
      name: '涉危情况管理',
      menuShow: true,
      leaf: true,
      children: []
    },
    {
      path: '/',
      component: Home,
      name: 'ereport',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/ereport',
        component: EReportList,
        name: '事件上报',
        menuShow: true
      },]
    },


    /*{
      path: '/',
      component: Home,
      name: 'employee manager',
      menuShow: true,
      leaf: true,
      children: [
        {path: '/employee', component: Employee, name: '员工管理', menuShow: true},
      ]
    },*/
    {
      path: '/',
      component: Home,
      name: 'post manager',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/post',
        component: Post,
        name: '职务管理',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: 'job manager',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/job',
        component: Job,
        name: '岗位管理',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: 'riskManagement public',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/publicRiskUnit',
        component: publicRiskUnit,
        name: '行业公有风险单元',
        menuShow: true
      },
        {
          path: '/base/basicInfo',
          component: () => import('@/pages/Hidden/base/basicInfo'),
          name: '隐患基础信息管理',
          menuShow: true
        },

      ]
    }, {
      path: '/',
      component: Home,
      name: 'Relevant',
      menuShow: true,
      leaf: true,
      children: []
    },
    {
      path: '/',
      component: Home,
      name: 'inspection',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/basicInfo',
        component: BasicInfo,
        name: '隐患基础信息管理',
        menuShow: true
      },
        {
          path: '/hrepository',
          component: HRepository,
          name: '隐患库管理',
          menuShow: true
        },
        {
          path: '/checkList/addFlow',
          component: () => import('@/pages/Hidden/checkList/listCheckAdd'),
          name: 'Add',
          menuShow: true
        },

        {
          path: '/hidden/list',
          component: () => import('@/pages/Hidden/list'),
          name: '隐患查询列表',
          menuShow: true
        },
        {
          path: '/check/list',
          component: CheckList,
          name: '排查列表',
          menuShow: true
        },
        {
          path: '/checkList',
          component: () => import('@/pages/Hidden/checkList/list'),
          name: '隐患单管理',
          menuShow: true
        },
        {
          path: '/hiddenCheckList',
          component: listHiddenCheckList,
          name: '隐患单排查',
          menuShow: true
        },
        {
          path: '/check/add',
          component: CheckAdd,
          name: '排查新增',
          menuShow: true
        },
        {
          path: '/abar/abarbeitung',
          component: () => import('@/pages/Hidden/abar/abarbeitung'),
          name: 'abarbeitung',
          menuShow: true
        },
        {
          path: '/review/review',
          component: () => import('@/pages/Hidden/review/review'),
          name: 'review',
          menuShow: true
        },
        {
          path: '/review/detail',
          component: () => import('@/pages/Hidden/review/detail'),
          name: '/review/detail',
          menuShow: true
        },
        {
          path: '/review/reviewaudit',
          component: () => import('@/pages/Hidden/review/reviewaudit'),
          name: 'reviewaudit',
          menuShow: true
        },
        {
          path: '/MajorHazard/MajorHazard',
          component: () => import('@/pages/Hidden/MajorHazard/MajorHazard'),
          name: 'MajorHazard',
          menuShow: true
        },
        {
          path: '/report/reportEdit',
          component: () => import('@/pages/Hidden/check/reportEdit'),
          name: 'ReportEdit',
          menuShow: true
        },
        {
          path: '/sisetu',
          component: () => import('@/pages/Hidden/sisetu'),
          name: '四色图',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'backlog',
      menuShow: true,
      leaf: false,
      children: [{
        path: '/backlog',
        component: () => import('@/pages/Backlog/backlog'),
        name: '待办事项',
        menuShow: true,
        leaf: true
      },
        {
          path: '/haveDone',
          component: HaveDone,
          name: '已办事项',
          menuShow: true,
          leaf: false
        }
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'riskPosition',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/riskPosition',
        component: RiskPosition,
        name: '风险点位置',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: 'version',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/version',
        component: Version,
        name: '版本号',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: 'approvalList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/approvalList',
        component: ApprovalList,
        name: '审批',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: '风险管控',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/riskControl',
        component: RiskControl,
        name: '风险分级管控',
        menuShow: true
      },
        {
          path: '/riskControlExport',
          component: () => import('@/pages/RiskManagement/riskControlExport'),
          name: '风险巡查统计',
          menuShow: true
        },
        {
          path: '/safetySignsType',
          component: () => import('@/pages/security/safetySignsType/list'),
          name: '安全标志类型管理',
          menuShow: true
        },
        {
          path: '/safetySigns',
          component: () => import('@/pages/security/safetySigns/list'),
          name: '安全标志管理',
          menuShow: true
        },
        {
          path: '/riskUnit',
          component: RiskUnit,
          name: '风险单元',
          menuShow: true
        },
        {
          path: '/riskEventType',
          component: RiskEventType,
          name: '企业事故类型管理',
          menuShow: true
        },
        {
          path: '/personnelPatrol',
          component: () => import('@/pages/RiskManagement/riskPersonnelPatrol'),
          name: '人员巡查情况',
          menuShow: true
        },
        {
          path: '/riskPatrol',
          component: () => import('@/pages/RiskManagement/riskPatrol'),
          name: '风险点巡查情况',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '安全管理',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/meetingCommittee',
        component: () => import('@/pages/security/meetingCommittee/list'),
        name: '安委会、例会',
        menuShow: true
      },
        {
          path: '/meetingClass',
          component: () => import('@/pages/security/meetingClass/list'),
          name: '班委会',
          menuShow: true
        },
        {
          path: '/securityMeeting',
          component: () => import('@/pages/security/securityMeeting/meetingList'),
          name: '安全会议',
          menuShow: true
        },
        {
          path: '/hazardSources/list',
          component: () => import('@/pages/security/hazardSources/list'),
          name: '重大危险源',
          menuShow: true
        },
        {
          path: '/devicesKeyparts/list',
          component: () => import('@/pages/security/devicesKeyparts/list'),
          name: '关键装置和重点部位',
          menuShow: true
        },
        {
          path: '/danger/list',
          component: () => import('@/pages/security/danger/list'),
          name: '危险化工工艺',
          menuShow: true
        },
        {
          path: '/endangeredProduct',
          component: () => import('@/pages/EntManagenment/endangered/product'),
          name: '涉危产品管理',
          menuShow: true
        },
        {
          path: '/enterprise/hazardousmaterials/list',
          component: () => import('@/pages/EntManagenment/hazardousmaterials/list'),
          name: '原辅助材料',
          menuShow: true
        },
        {
          path: '/EnterpriseFile/Equipment',
          component: () => import('@/pages/enterpriseFile/Equipment/list'),
          name: '设备设施管理',
          menuShow: true
        },
        {
          path: '/EnterpriseFile/special',
          component: () => import('@/pages/enterpriseFile/Equipment/special'),
          name: '特种设备管理',
          menuShow: true
        },
        {
          path: '/EnterpriseFile/maintainPlan',
          component: () => import('@/pages/enterpriseFile/maintain/planList'),
          name: '设备设施维护保养计划',
          menuShow: true
        },
        {
          path: '/EnterpriseFile/inspectBase',
          component: () => import('@/pages/enterpriseFile/inspect/baseList'),
          name: '设备设施点检模板',
          menuShow: true
        },
        {
          path: '/EnterpriseFile/inspect',
          component: () => import('@/pages/enterpriseFile/inspect/list'),
          name: '设备设施点检',
          menuShow: true
        },
        {
          path: '/relevant',
          component: Relevant,
          name: '相关方管理',
          menuShow: true
        },
        {
          path: '/relevantApproval',
          component: () => import('@/pages/thirdParty/relevant/approval'),
          name: '相关方审批',
          menuShow: true
        },
        {
          path: '/relevantExamineBase',
          component: () => import('@/pages/thirdParty/examine/baseList'),
          name: '相关方考核模板',
          menuShow: true
        },
        {
          path: '/relevantExamine',
          component: () => import('@/pages/thirdParty/examine/list'),
          name: '相关方考核',
          menuShow: true
        },
        {
          path: '/relevantExamineFuben',
          component: () => import('@/pages/thirdParty/examine/list-fuben'),
          name: '相关方考核',
          menuShow: true
        },
        {
          path: '/relevantExamineApproval',
          component: () => import('@/pages/thirdParty/examine/approval'),
          name: '相关方考核审批',
          menuShow: true
        },
        {
          path: '/relevantRisk',
          component: () => import('@/pages/thirdParty/risk/list'),
          name: '相关方作业行为风险评估',
          menuShow: true
        },
        {
          path: '/relevantRiskBase',
          component: () => import('@/pages/thirdParty/risk/base'),
          name: '风险评估项目管理设置',
          menuShow: true
        },
        {
          path: '/relevantCheck',
          component: () => import('@/pages/thirdParty/check/list'),
          name: '施工方现场检查记录',
          menuShow: true
        },
        {
          path: '/relevantCheckBase',
          component: () => import('@/pages/thirdParty/check/base'),
          name: '施工方现场检查项目设置',
          menuShow: true
        },
        {
          path: '/relevantSafety',
          component: () => import('@/pages/thirdParty/safety/list'),
          name: '安全告知管理',
          menuShow: true
        },
        {
          path: '/meetingPlan',
          component: () => import('@/pages/security/meetingPlan/list'),
          name: '会议计划',
          menuShow: true
        },
        {
          path: '/blacklist',
          component: () => import('@/pages/thirdParty/blacklist/blacklist'),
          name: '黑名单',
          menuShow: true
        },
        {
          path: '/assessmentRanking',
          component: () => import('@/pages/thirdParty/assessmentRanking/list'),
          name: '考核排名',
          menuShow: true
        },
        {
          path: '/EnterpriseFile/maintain',
          component: () => import('@/pages/enterpriseFile/maintain/list'),
          name: '设备保养记录',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '汇总统计',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/chart/inspection',
        component: () => import('@/pages/statistics/chartInspection'),
        name: '隐患情况',
        menuShow: true
      },
        {
          path: '/chart/edu',
          component: () => import('@/pages/statistics/chartEdu'),
          name: '教育培训',
          menuShow: true
        },
        {
          path: '/chart/licence',
          component: () => import('@/pages/statistics/chartLicence'),
          name: '证照',
          menuShow: true
        },
        {
          path: '/chart/equip',
          component: () => import('@/pages/statistics/chartEquip'),
          name: '设备设施',
          menuShow: true
        },
        {
          path: '/chart/specialEquip',
          component: () => import('@/pages/statistics/chartSpecialEquip'),
          name: '特种设备',
          menuShow: true
        },
        {
          path: '/chart/health',
          component: () => import('@/pages/statistics/chartHealth'),
          name: '职业健康',
          menuShow: true
        },
        {
          path: '/chart/drill',
          component: () => import('@/pages/statistics/chartDrill'),
          name: '应急演练统计',
          menuShow: true
        },
        {
          path: '/chart/risk',
          component: () => import('@/pages/statistics/chartRisk'),
          name: '风险管控',
          menuShow: true
        },


        // {path: '/staInspection',component: () => import('@/pages/statistics/inspectionList'), name: '隐患治理统计', menuShow: true},
        // {path: '/trainingStatistics',component: () => import('@/pages/statistics/trainingStatistics'), name: '培训演练统计', menuShow: true},
        // {path: '/staEvent',component: () => import('@/pages/statistics/eventList'), name: '安全事故统计', menuShow: true},
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'knowledgeBaseLawList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/knowledgeBase/lawList',
        component: LawList,
        name: '法律法规',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: 'knowledgeBaseSublist',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/knowledgeBase/sublist',
        component: SubList,
        name: '法律法规（子公司）',
        menuShow: true
      },]
    },
    {
      path: '/',
      component: Home,
      name: 'knowledgeBaseRulesTypeList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/knowledgeBase/rulesTypeList',
        component: RulesTypeList,
        name: '规程类型',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: 'knowledgeBaseRulesList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/knowledgeBase/rulesList',
        component: RulesList,
        name: '规程',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: '安全目标名称',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/security/seTargetName',
        component: SeTargetNameList,
        name: '安全目标名称管理',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: '安全目标',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/security/seTarget',
        component: SeTargetList,
        name: '安全目标管理',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: 'securitySeNextList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/security/seNextList',
        component: SeNextList,
        name: '待完成安全目标',
        menuShow: true
      },]
    }, , {
      path: '/',
      component: Home,
      name: 'dangerousJobFire',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/HotWork/dangerousJobFire',
        component: () => import('@/pages/HotWork/dangerousJobFire'),
        name: '动火作业初步申请',
        menuShow: true
      },
        {
          path: '/task/lgnitionTask/list',
          component: () => import('@/pages/task/lgnitionTask/list'),
          name: '动火作业证',
          menuShow: true
        },
        {
          path: '/lgnitionTask/sign',
          component: () => import('@/pages/task/examine/sign'),
          name: '证件会签',
          menuShow: true
        },
        {
          path: '/lgnitionTask/preliminaryAudit',
          component: () => import('@/pages/task/examine/preliminaryAudit'),
          name: '初审',
          menuShow: true
        },
        {
          path: '/lgnitionTask/whenHot',
          component: () => import('@/pages/task/examine/whenHot'),
          name: '证件动火',
          menuShow: true
        },
        {
          path: '/lgnitionTask/workCertificate',
          component: () => import('@/pages/task/examine/workCertificate'),
          name: '证件打印',
          menuShow: true
        },
        {
          path: '/lgnitionTask/file',
          component: () => import('@/pages/task/examine/file'),
          name: '证件归档',
          menuShow: true
        },
        {
          path: '/lgnitionTask/acceptance',
          component: () => import('@/pages/task/examine/acceptance'),
          name: '证件验收',
          menuShow: true
        },
        {
          path: '/lgnitionTask/listBase',
          component: () => import('@/pages/task/securityBaseInfo/listBase'),
          name: '证件基础安全措施信息',
          menuShow: true
        },
        {
          path: '/lgnitionTask/reportJobFire',
          component: () => import('@/pages/task/examine/reportJobFire'),
          name: '动火作业证申请',
          menuShow: true
        },
        {
          path: '/HotWork/reportJobFire',
          component: () => import('@/pages/HotWork/reportJobFire'),
          name: '动火申请',
          menuShow: true
        },
        {
          path: '/HotWork/dangerousJobBasics',
          component: () => import('@/pages/HotWork/dangerousJobBasics'),
          name: '动火措施基础信息',
          menuShow: true
        },
        {
          path: '/HotWork/preliminaryAudit',
          component: () => import('@/pages/HotWork/preliminaryAudit'),
          name: '初步审核',
          menuShow: true
        },
        {
          path: '/HotWork/OnSiteAudit',
          component: () => import('@/pages/HotWork/OnSiteAudit'),
          name: '现场审核',
          menuShow: true
        },
        {
          path: '/HotWork/sign',
          component: () => import('@/pages/HotWork/sign'),
          name: '会签',
          menuShow: true
        },
        {
          path: '/HotWork/workCertificate',
          component: () => import('@/pages/HotWork/workCertificate'),
          name: '作业证打印',
          menuShow: true
        },
        {
          path: '/HotWork/WhenHot',
          component: () => import('@/pages/HotWork/WhenHot'),
          name: '动火',
          menuShow: true
        },
        {
          path: '/HotWork/acceptance',
          component: () => import('@/pages/HotWork/acceptance'),
          name: '验收',
          menuShow: true
        },
        {
          path: '/limitSpace/list',
          component: () => import('@/pages/task/limitSpace/list'),
          name: '受限空间安全作业证管理',
          menuShow: true
        },
        {
          path: '/highWok/list',
          component: () => import('@/pages/task/highWok/list'),
          name: '高处安全作业管理',
          menuShow: true
        },
        {
          path: '/blindTakeBlock',
          component: () => import('@/pages/task/blindTakeBlock/blindTakeBlock'),
          name: '盲板抽堵安全作业证管理',
          menuShow: true
        },
        {
          path: '/leftWok/list',
          component: () => import('@/pages/task/leftWok/list'),
          name: '吊装安全作业管理',
          menuShow: true
        },
        {
          path: '/tempEle/list',
          component: () => import('@/pages/task/tempEle/list'),
          name: '临时用电安全作业管理',
          menuShow: true
        },
        {
          path: '/certGround',
          component: () => import('@/pages/task/certGround/certGround'),
          name: '动土安全作业证管理',
          menuShow: true
        },
        {
          path: '/roadBroken',
          component: () => import('@/pages/task/roadBroken/roadBroken'),
          name: '断路安全作业证管理',
          menuShow: true
        },

      ]
    }, {
      path: '/',
      component: Home,
      name: 'enterpriseEntAttList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/enterprise/entAttList',
        component: EntAttList,
        name: '企业属性',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: 'securityStandardList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/security/standardList',
        component: StandardList,
        name: '行业化达标',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: 'securityIndustryList',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/security/industryList',
        component: IndustryList,
        name: '行业资质',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: '企业体系文件',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/invest/list',
        component: () => import('@/pages/enterpriseFile/invest/list'),
        name: '安全投入计划',
        menuShow: true
      },
        {
          path: '/invest/ledger',
          component: () => import('@/pages/enterpriseFile/invest/ledgerlist'),
          name: '安全费用使用台账',
          menuShow: true
        },
        {
          path: '/invest/subjectlist',
          component: () => import('@/pages/enterpriseFile/invest/subjectlist'),
          name: '费用科目',
          menuShow: true
        },
      ]
    }, {
      path: '/',
      component: Home,
      name: 'project manager',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/project',
        component: ProList,
        name: '项目管理',
        menuShow: true
      },]
    }, {
      path: '/',
      component: Home,
      name: '基础库管理',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/dictionary/list',
        component: DictionaryList,
        name: '基础字典管理',
        menuShow: true
      },
        {
          path: '/typeDictionary/list',
          component: TypeDictionaryList,
          name: '基础类别字典管理',
          menuShow: true
        },
        {
          path: '/regulations/list',
          component: () => import('@/pages/security/regulations/list'),
          name: '基础操作规程',
          menuShow: true
        },
        {
          path: '/dangerBase/list',
          component: () => import('@/pages/security/dangerBase/list'),
          name: '基础危险化工工艺',
          menuShow: true
        },
        {
          path: '/templateMatters',
          component: () => import('@/pages/Template/templateMatters'),
          name: '注意事项基础信息管理',
          menuShow: true
        },
        {
          path: '/templatePrecautions',
          component: () => import('@/pages/Template/templatePrecautions'),
          name: '安全措施基础信息管理',
          menuShow: true
        },
        // {path: '/base/basicInfo', component: () => import('@/pages/Hidden/base/basicInfo'), name: '隐患基础信息管理', menuShow: true},
      ]
    }, {
      path: '/',
      component: Home,
      name: '培训管理',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/training/trainingPlan',
        component: () => import('@/pages/training/trainingPlan'),
        name: '培训计划',
        menuShow: true
      },
        {
          path: '/training/trainingSituation',
          component: () => import('@/pages/training/trainingSituation'),
          name: '培训情况',
          menuShow: true
        },
        {
          path: '/training/course',
          component: Course,
          name: '课程管理',
          menuShow: true
        },
        {
          path: '/training/questionBank',
          component: () => import('@/pages/training/questionBank'),
          name: '题库管理',
          menuShow: true
        },
        {
          path: '/training/topic',
          component: () => import('@/pages/training/topic'),
          name: '提干管理',
          menuShow: true
        },
        {
          path: '/training/testPaper',
          component: () => import('@/pages/training/testPaper'),
          name: '试卷管理',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '证照管理',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/card/userCard',
        component: () => import('@/pages/card/userCard'),
        name: '证照采集',
        menuShow: true
      },
        {
          path: '/card/userCardReview',
          component: () => import('@/pages/card/userCardReview'),
          name: '证照复审',
          menuShow: true
        },
        {
          path: '/card/userCardWarn',
          component: () => import('@/pages/card/userCardWarn'),
          name: '证照过期预警',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '学习园地',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/security/staPlaList',
        component: () => import('@/pages/security/security/staPlaList'),
        name: '标准规范',
        menuShow: true
      },
        {
          path: '/security/accCasList',
          component: () => import('@/pages/security/security/accCasList'),
          name: '事故案例库',
          menuShow: true
        },
        {
          path: '/security/safCulList',
          component: () => import('@/pages/security/security/safCulList'),
          name: '安全文化',
          menuShow: true
        },
        {
          path: '/security/safKnoList',
          component: () => import('@/pages/security/security/safKnoList'),
          name: '安全知识',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '系统监控',
      menuShow: true,
      leaf: true,
      children: [{
        path: '/hystrix',
        meta: {
          url: 'https://www.baidu.com'
        },
        component: () => import('@/pages/SystemControl/hystrix'),
        name: 'Hystirx监控面板',
        menuShow: true
      },
        {
          path: '/registry',
          meta: {
            url: 'https://www.runoob.com'
          },
          component: () => import('@/pages/SystemControl/registry'),
          name: '服务注册',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '隐患计划管理',
      menuShow: true,
      leaf: false,
      children: [{
        path: '/inspectionPlan/plan',
        component: () => import('@/pages/inspectionPlan/plan'),
        name: '隐患计划',
        menuShow: true,
        leaf: true
      },
        {
          path: '/inspectionPlan/check',
          component: () => import('@/pages/inspectionPlan/check'),
          name: '隐患计划排查',
          menuShow: true,
          leaf: true
        },
      ]
    }, {
      path: '/',
      component: Home,
      name: 'MeetingPlanMessageList',
      menuShow: true,
      leaf: true,
      children: [
        {
          path: '/messageList',
          component: () => import('@/pages/security/meetingPlan/messageList'),
          name: '消息列表',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'archivesDetailsRepeat',
      menuShow: true,
      leaf: true,
      children: []
    },
    {
      path: '/',
      component: Home,
      name: 'questionnaire',
      menuShow: true,
      leaf: true,
      children: [
        {
          path: '/questionnaire',
          component: () => import('@/pages/student/questionnaire/questionnaire'),
          name: '问卷',
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: 'tariningPrograms',
      menuShow: true,
      leaf: true,
      children: [
        {
          path: '/tariningProgramList',
          component: () => import('@/pages/trainingManagement/safetyTrainingProgram/trainingProgram/list'),
          name: '培训计划选择',
          menuShow: true
        },
      ]
    },
    {
      path: '/',
      component: Home,
      name: '代理商管理',
      menuShow: true,
      leaf: true,
      children: [
        {
          path: '/agent',
          component: () => import('@/pages/trainingManagement/agent/list'),
          name: '代理商管理',
          menuShow: true,
          leaf: true
        }
      ]
    },
    ...newRouter
  ]
})

//begin
router.beforeEach((to, from, next) => {
  config.initConfig(window.location.hostname);
  // 判断是否是商城
  if (!config.includeMall && to.meta.group == 'mall') {
    next({
      path: '/login'
    })
    return;
  }
  if (to.path.startsWith('/login')) {
    window.localStorage.removeItem('access-token')
    next()
  }else if (to.path.startsWith('/org-login')) {
    // window.localStorage.removeItem('access-token')
    next()
  }
  else if (to.path.startsWith('/index')) {
    next()
  }else if (to.path.startsWith('/indexs')) {
    next()
  }
  else if (to.path.startsWith('/h/mall/type')) {
    next()
  } else if (to.path.startsWith('/success')) {
    next()
  } else if (to.path.startsWith('/register')) {
    next()
  } else if (to.path.startsWith('/cadet/register')) {
    next()
  } else if (to.path.startsWith('/demo')) {
    next()
  } else if (to.path.startsWith('/chart001')) {
    next()
  } else if (to.path.startsWith('/activate')) {
    next()
  } else if (to.path.startsWith('/videoList')) {
    next()
  } else if (to.path.startsWith('/invite')) {
    next()
  }
  //监管端
  else if (to.path.startsWith('/supervise')) {
    let user = window.localStorage.getItem('access-token');
    if (!user) {
      next({
        path: '/jg-login'
      })
    } else {
      next()
    }

  } else if (to.path.startsWith('/jg-login')) {
    next()
  }
    // else if (to.path.startsWith('/course/mall')) {
    //   next()
  // }
  else if (to.path.startsWith('/recommend')) {
    next()
  } else if (to.path.startsWith('/customer')) {
    next()
  } else if (to.path.startsWith('/detail')) {
    next()
  } else if (to.path.startsWith('/h/mall')) {
    next()
  } else if (to.path.startsWith('/enter')) {
    next()
  } else if (to.path.startsWith('/indexCes')) {
    next()
  } else if (to.path.startsWith('/web-index')) {
    next()
  }
  // else if (to.path.startsWith('/webs-index')) {
  //   next()
  // }
  else if (to.path.startsWith('/about')) {
    next()
  } else if (to.path.includes('http')) {
    window.open(to.fullPath.substr(1));
  } else {
    let user = window.localStorage.getItem('access-token');
    if (!user) {
      // next({
      //   path: '/webs-index'
      // })
      next({
        path: '/login'
      })
    } else {
      // TODO 这个代码有bug，会影响到其他平台ifname 内。没测试改好千万不要发布的线上
      // let userinfo = window.localStorage.getItem('userinfo');
      // if (userinfo.initializationState && userinfo.initializationState == 1) {
      //   next({path: '/user/changepwd?type=initialization'})
      // }
      //判断是否为第三方平台嵌入， 如果是第三方嵌入，那么就进行用户数据的初始化操作
      if (window.localStorage.getItem("isEmbed") == "true") {
        let isEmbedInitData = window.localStorage.getItem("isEmbedInitData");
        if (isEmbedInitData != "true") {
          initEmbedData(next);
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
})

/**
 * 初始化嵌入模式的数据数据
 * @param next 路由（需要等用户信息初始化完成后再做跳转，否则存在页面获取不到 localStorage 中的数据）
 * @returns {Promise<void>}
 */
async function initEmbedData(next) {
  //标记嵌入初始化完成
  window.localStorage.setItem("isEmbedInitData", true);

  //初始化用户数据
  await api_user.currentUserInfo().then(result => {
    debugger
    let userInfo = result.data;
    localStorage.setItem('userinfo', JSON.stringify(userInfo));
    localStorage.setItem('oldVersion', userInfo.version);
    localStorage.setItem('parent-company-id', userInfo.parentEnterpriseId);
    console.log('current user info ', userInfo);
    debugger
    next();
  });

  // 获取专业类别
  DIC_API.getDictionaryTreeToMapAndList({
    code: $const.dictionary.TRAINING_INDUSTRY,
  }).then(result => {
    localStorage.setItem("categoryList", JSON.stringify(result.data.datas));
    localStorage.setItem("industryMapObj", JSON.stringify(result.data.dataMap));
  });

  // 题型
  DIC_API.getListByParentCode({
    parentCode: "QUESTION"
  }).then(result => {
    localStorage.setItem("questionTypeList", JSON.stringify(result));
  });

  // 部门列表
  api_dept.getlistAll().then(res => {
    localStorage.setItem("departmentList", JSON.stringify(res.data));
  });

  // 负责人列表
  api_user.listNopagging().then(res => {
    localStorage.setItem("principalList", JSON.stringify(res));
  });

  // 获取部门树形结构
  api_dept.getTree().then(res => {
    localStorage.setItem("deptTree", JSON.stringify(res));
  });

  // 获取教学方式
  DIC_API.getListByParentCode({
    parentCode: "teaching_methods"
  }).then(result => {
    localStorage.setItem("teaching_methods", JSON.stringify(result));
  });

  // 获取教学方式
  DIC_API.getListByParentCode({
    parentCode: "assess_methods"
  }).then(result => {
    localStorage.setItem("assess_methods", JSON.stringify(result));
  });
  // 考试类型
  DIC_API.getListByParentCode({
    parentCode: "exam_type"
  }).then(result => {
    localStorage.setItem("exam_type", JSON.stringify(result));
  });
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js